/* eslint-disable import/prefer-default-export */

export const EXAMS = [
  {
    name: 'SIE',
    fullName: 'Securities Industry Essentials',
    to: '/exams/finra-sie/overview/',
    product: 'finra-sie',
  },
  {
    name: 'Series 6',
    fullName: 'Investment and Variable Products Representative',
    to: '/exams/finra-series-6/overview/',
    product: 'finra-series-6',
  },
  {
    name: 'Series 7',
    fullName: 'General Securities Representative',
    to: '/exams/finra-series-7/overview/',
    product: 'finra-series-7',
  },
  {
    name: 'Series 9',
    fullName: 'General Securities Sales Supervisor',
    to: '/exams/finra-series-9/overview/',
    product: 'finra-series-9',
  },
  {
    name: 'Series 63',
    fullName: 'Uniform Securities Agent State Law',
    to: '/exams/finra-series-63/overview/',
    product: 'finra-series-63',
  },
  {
    name: 'Series 65',
    fullName: 'Uniform Investment Advisor Law',
    to: '/exams/finra-series-65/overview/',
    product: 'finra-series-65',
  },
  {
    name: 'Series 66',
    fullName: 'Uniform Combined State Law',
    to: '/exams/finra-series-66/overview/',
    product: 'finra-series-66',
  },
  {
    name: 'Life & Health',
    fullName: 'Life & Health Insurance',
    to: '/exams/insurance-life-health/overview/',
    product: 'insurance-life-health',
  },
  {
    name: 'ACT',
    fullName: 'American College Testing',
    to: '/exams/act/overview/',
    product: 'act',
  },
  {
    name: 'CLT',
    fullName: 'Classic Learning Test',
    to: '/exams/clt/overview/',
    product: 'clt',
  },
  {
    name: 'GRE',
    fullName: 'Graduate Record Examinations',
    to: '/exams/gre/overview/',
    product: 'gre',
  },
  {
    name: 'USMLE',
    fullName: 'United States Medical Licensing Examination',
    to: '/exams/usmle-step-1/overview/',
    product: 'usmle-step-1',
  },
  {
    name: 'AMC 8/10/12',
    fullName: 'American Mathematics Contest 8/10/12',
    to: '/exams/amc-8-10-12/overview/',
    product: 'amc-8-10-12',
  },
];

export const FINRA_PRODUCTS = [
  'finra-sie',
  'finra-series-6',
  'finra-series-7',
  'finra-series-9',
];
export const FINRA_EXAMS = EXAMS.filter((exam) => FINRA_PRODUCTS.includes(exam.product));

export const NASAA_PRODUCTS = ['finra-series-63', 'finra-series-65', 'finra-series-66'];
export const NASAA_EXAMS = EXAMS.filter((exam) => NASAA_PRODUCTS.includes(exam.product));

export const INSURANCE_PRODUCTS = ['insurance-life-health'];
export const INSURANCE_EXAMS = EXAMS.filter((exam) =>
  INSURANCE_PRODUCTS.includes(exam.product)
);

export const EDUCATION_PRODUCTS = ['act', 'clt', 'gre', 'usmle-step-1', 'amc-8-10-12'];
export const EDUCATION_EXAMS = EXAMS.filter((exam) =>
  EDUCATION_PRODUCTS.includes(exam.product)
);
